import { useHomeSearchSettingsContext } from "@pages/Home/HomeContext";
import { useEffect } from "react";
import { useSelectFilters } from "@vms/SelectFilters/SelectFiltersContext";

export function useFiltersSettings() {
    const { data } = useHomeSearchSettingsContext();
    const {
        setAppliedFilters,
        setSelectedFilters,
    } = useSelectFilters();

    useEffect(() => {
        if (data?.filters) {
            setSelectedFilters(data.filters);
            setAppliedFilters(data.filters);
        }
    }, [data, setAppliedFilters, setSelectedFilters]);
}